module.exports = __webpack_public_path__ + "static/one-aba71e4047871d27114a8f8acbfac292.mp4";